"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSvgToImage = exports.getRTRFontStyle = exports.setRTRFontForCanvasContext = exports.waitForFonts = void 0;
var waitForFonts = function (font) {
    return new Promise(function (resolve, reject) {
        document.fonts
            .load(font)
            .then(function () {
            resolve(true);
        })
            .catch(function (error) {
            reject(error);
        });
    });
};
exports.waitForFonts = waitForFonts;
var setRTRFontForCanvasContext = function (context, layer) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, textColor, _b, fontFamily, _c, textSize, _d, textAlign, font, error_1;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = layer.text_color, textColor = _a === void 0 ? "#000" : _a, _b = layer.text_font, fontFamily = _b === void 0 ? "StyreneRegular" : _b, _c = layer.text_size, textSize = _c === void 0 ? "32" : _c, _d = layer.alignment, textAlign = _d === void 0 ? "left" : _d;
                font = "".concat(parseInt(textSize, 10), "px ").concat(fontFamily);
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, exports.waitForFonts)(font)];
            case 2:
                _e.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _e.sent();
                return [3 /*break*/, 4];
            case 4:
                context.font = font;
                context.textAlign = textAlign;
                context.textBaseline = "top";
                context.fillStyle = textColor;
                return [2 /*return*/];
        }
    });
}); };
exports.setRTRFontForCanvasContext = setRTRFontForCanvasContext;
var getRTRFontStyle = function (layer) { return __awaiter(void 0, void 0, void 0, function () {
    var css_style, _a, textAlign;
    return __generator(this, function (_b) {
        css_style = layer.css_style, _a = layer.horizontal_alignment, textAlign = _a === void 0 ? "left" : _a;
        // // TODO: Fix
        // const font = `${fontFamily}`;
        // // Wait for fonts
        // try {
        //   await waitForFonts(font);
        // } catch (error) {
        //   // Ignore for now
        // }
        return [2 /*return*/, "".concat(css_style, ";  text-align: ").concat(textAlign, ";")];
    });
}); };
exports.getRTRFontStyle = getRTRFontStyle;
var convertSvgToImage = function (svg, height, width) {
    return new Promise(function (resolve, reject) {
        var tempImage = new Image();
        tempImage.height = height;
        tempImage.width = width;
        var svgData = "data:image/svg+xml;base64," +
            btoa(unescape(encodeURIComponent(new XMLSerializer().serializeToString(svg))));
        tempImage.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, width, height);
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(tempImage, 0, 0);
            var pngData = canvas.toDataURL("image/png");
            resolve(pngData);
        };
        tempImage.onerror = tempImage.onabort = function () {
            reject();
        };
        tempImage.src = svgData;
    });
};
exports.convertSvgToImage = convertSvgToImage;
